<template>
  <div class="common__pageContainer__3-VhW">
    <!-- 网站弹窗 -->

    <div class="msgBox__modal__2kbbd" data-analytics="button" data-label="msg关闭" v-if="$store.state.appInfo.index_modal == 1 && tanshow" style="display: block">
      <div class="msgBox__modal_HomeAreat_model__2obMO msgBox__modal_CuorsterAreat_model__wwzuA">
        <div class="msgBox__notice_header__kkFdX">
          <span class="msgBox__text__2ODn2" title="">欢迎来到{{ $store.state.appInfo.title }}</span
          ><span class="msgBox__close_icon__3J9a5" @click="changtanshow"></span>
        </div>
        <div class="msgBox__notice_content__3Tozy msgBox__notice_content_height__Z3O1m">
          <div class="msgBox__flex__-7cOr common__scroll_bar__28TB7" v-html="$store.state.appInfo.webcontent"></div>
          <div class="msgBox__footer__3DHzZ"><button class="msgBox__confirm__3ypnx" type="button" @click="changtanshow">关闭</button></div>
        </div>
      </div>
    </div>


    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/userredpacket')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>
    <div class="common__pageBody__1Dn3a">
      <div class="home__home_page_layout__3bSUu index__wrapper__3VwKM" style="background-image: url(/static/image/bg.4dd7830db13982d6a052e96dd6332c07.jpg); min-height: 3000px">
        <div class="banner__wrapBanner__1FaRM">
          <div class="style__banner__28HI6 mySwiper swiper-initialized swiper-horizontal swiper-pointer-events">
            <div class="style__wrapper__1mxxP swiper-wrapper">
              <div v-for="(item, index) in bannerList" :key="index" class="style__bannerItem__34zkO swiper-slide" :style="`background-image: url(${item.src}); width: 1087px`"></div>
            </div>
            <div class="style__dots__2wknW swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
            <div class="style__prev__14mIE" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-3a5aceb5b3dfd6310"></div>
            <div class="style__next__3f6-g" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-3a5aceb5b3dfd6310"></div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>

        <div class="msgBox__modal__2kbbd" data-analytics="button" data-label="msg关闭" v-if="message" style="display: block">
          <div class="msgBox__modal_HomeAreat_model__2obMO msgBox__modal_CuorsterAreat_model__wwzuA">
            <div class="msgBox__notice_header__kkFdX"><span class="msgBox__text__2ODn2" title="">最新公告</span><span class="msgBox__close_icon__3J9a5" @click="changMessage(null)"></span></div>
            <div class="msgBox__notice_content__3Tozy msgBox__notice_content_height__Z3O1m">
              <div class="msgBox__flex__-7cOr common__scroll_bar__28TB7" v-for="(item, index) in homenoticelis" :key="index" v-if="index < 2">
                <p>{{ item }}</p>
              </div>
              <div class="msgBox__footer__3DHzZ"><button class="msgBox__close__3a3LR" type="button" @click="changMessage(null)">关闭</button><button class="msgBox__confirm__3ypnx" type="button" @click="$parent.goNav('/message')">查看全部公告</button></div>
            </div>
          </div>
        </div>
        <div class="notice__led__15X-v">
          <section class="home__led__24I0q">
            <div class="home__notice_box__MTDrm" style="background-color: rgb(238, 243, 247)">
              <div class="home__notice__2dv3X" style="overflow: visible">
                <div class="home__title__vakp6"><img src="/static/image/icon-laba.051833f608cedb8253e72e6e93fd6e1c.svg" width="20px" height="24px" /></div>
                <div class="home__noticelist__1AaLZ home__str_wrap__3K769">
                  <div class="home__notice_wrap__2_0lO">
                    <div class="marquee-container" style="--pause-on-hover: paused; --pause-on-click: running">
                      <div class="marquee" style="--play: running; --direction: normal; --duration: 660.559s; --delay: 2s; --iteration-count: infinite">
                        <p class="home__marquee__3d0Ok" @click="changMessage(1)">
                          <a style="height: 50px; line-height: 50px" v-for="(item, index) in homenoticelis" :key="index">{{ item }}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="fl" style="text-align: center">
                  <a class="home__cuorster__17Pr8" @click="$parent.goNav('/message')" style="width: 96px; text-align: right"><button class="notice__more__2MgRR">更多</button></a>
                </p>
              </div>
            </div>
          </section>
        </div>
        <div class="sponsor__wrapper__3Wi1o">
          <div class="sponsor__item__14Sa8" @click="$parent.openPage('/asdwl?type=1')"><img src="/static/image/invalid-name@2x.aa69bc6e48a7db32e690d1c67a4ddec1.png" width="626px" height="180px" /></div>
          <div class="sponsor__item__14Sa8" @click="$parent.openPage('/asdwl?type=2')"><img src="/static/image/asidunlawei@2x.07eeb5904586eafb13a9b498743f53d9.png" width="626px" height="180px" /></div>
        </div>
        <div class="scrollLazy" style="min-height: 200px">
          <div class="appdownload__appDownload__28OI- animation-show" id="appDownload" animation-show="true">
            <img src="/static/image/shoujiappxiazai@2x.11b8ec3083d9c0c052b2f8cde0043dcc.png" width="480px" />
            <div class="appdownload__downContainer__2Yz3A">
              <div class="appdownload__leftSide__2K_EM">
                <div class="appdownload__appDownloadOne__2Bth6 appdownload__active__1p3Q_"><img src="/static/image/zh.362e9e141ea5be7505e921577983e622.png" width="698px" class="appdownload__iphone1__d-ys5 appdownload__iphone1enter__18nrh" data-type="zh" /></div>
                <div class="appdownload__appDownloadOne__2Bth6"><img src="/static/image/tiyu.320cff4864a85c7829620bf8577082fc.png" width="698px" class="appdownload__iphone2__1KetS appdownload__iphone1enter__18nrh" data-type="ty" /></div>
                <div class="appdownload__appDownloadOne__2Bth6"><img src="/static/image/cp.f7fd720b5960205cd8dfeaec4c048379.png" width="698px" class="appdownload__iphone3__1mcq5 appdownload__iphone1enter__18nrh" data-type="cp" /></div>
                <div class="appdownload__appDownloadOne__2Bth6"><img src="/static/image/qp.07e41c5b711af6021e3cc2378e21b948.png" width="696px" class="appdownload__iphone3__1mcq5 appdownload__iphone1enter__18nrh" data-type="qp" /></div>
              </div>
              <div class="appdownload__rightSide__gWFaK">
                <div class="appdownload__tabs__3tvRx"></div>
                <div class="appdownload__rightSideContainer__2lGDq appdownload__active__1p3Q_">
                  <img src="/static/image/app-sub-title.ea5de3f59f0d4e8129b37826dc6272fb.png" width="218px" class="appdownload__enjoy__3FakM" />
                  <p class="appdownload__description__3YMx1">棋牌、彩票、真人娱乐、体育赛事、电子游艺、电子竞技，您所要的尽在{{ $store.state.appInfo.title }}。行业种类最全娱乐竞技APP，{{ $store.state.appInfo.title }}为您呈现别样、缤纷的极致体验。</p>
                  <div class="appdownload__qcodeContainer__3VX0A">
                    <!--           // "ios_download_qrcode": "http://mb2.tg-demo.cc:86/uploads/images/e13177382b3e958789c877f71b034ca9.jpg",
          // "ios_download_url": "http://mb2.tg-demo.cc:86/",
          // "h5_url": "http://mb2m.tg-demo.cc" -->
                    <div class="appdownload__topSide__27gqv">
                      <div class="appdownload__codeWrapper__3eWWV">
                        <img :src="$store.state.appInfo.ios_download_qrcode" onerror="this.src = '/static/image/appurl.jpg'" width="152" height="152" />
                      </div>
                      <div>
                        <p class="appdownload__botSide__3kjmH">
                          扫码下载APP<br />
                          支持IOS &amp; Android全设备<br />
                          <a :href="$store.state.appInfo.ios_download_url" target="_blank" style="color: rgb(70, 119, 255); visibility: visible">{{ $store.state.appInfo.ios_download_url }}</a>
                        </p>
                      </div>
                    </div>
                    <div class="appdownload__topSide__27gqv appdownload__topSide1__3qE_b">
                      <div class="appdownload__codeWrapper__3eWWV"><img src="/static/image/zhijiefangwen@2x.3dfa4abeebf46d64aea082e3d55560c1.png" width="126px" class="appdownload__h5__2f17w" style="margin-left: 10px" /></div>
                      <div>
                        <p class="appdownload__botSide__3kjmH undefined">
                          无需下载直接访问<br />
                          手机输入网址即可访问<br />
                          <a :href="$store.state.appInfo.h5_url" style="color: rgb(70, 119, 255); cursor: pointer; visibility: visible">{{ $store.state.appInfo.h5_url }}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="scrollLazy" style="min-height: 200px">
          <div class="games__container__1thqP animation-show" animation-show="true">
            <div class="games__wrapper__2V0hx">
              <div class="games__title__b8RO0"><img src="/static/image/games_title.9badfadfc430eedb4aa92ad013ca2db8.png" width="408px" /></div>
              <div class="games__content__2kgrX">
                <ul>
                  <li class="games__active__2El6O" id="game-li-0" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1">
                    <span>体育赛事</span><img src="/static/image/xuanzhongtiyu@2x.876783ff5a66e88140ce3370a090dac7.png" height="40px" />
                  </li>
                  <li id="game-li-1" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1" class="">
                    <span>电子竞技</span><img src="/static/image/weixuanzhongdianzijingji@2x.ac09f7ec18cbaf9e8f9b27586e3c6918.png" height="40px" style="" />
                  </li>
                  <li id="game-li-2" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1" class="">
                    <span>真人娱乐</span><img src="/static/image/weixuanzhongzhenren@2x.e72bd355569a0afc9bc6e27774e54fd5.png" height="40px" style="" />
                  </li>
                  <li id="game-li-3" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1" class="">
                    <span>棋牌游戏</span><img src="/static/image/weixuanzhongqipai@2x.e0475d86c580d8f1cbdf06818842fb95.png" height="40px" />
                  </li>
                  <li class="games__cp__15BKF" id="game-li-4" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1">
                    <span>彩票投注</span><img src="/static/image/weixuanzhongcaipiao@2x.1d4c546588d5bc631c706d92b2988b1f.png" height="40px" style="" />
                  </li>
                  <li class="games__dz__Jil0M" id="game-li-5" style="background-image: url(style/weixuanzhonganniu@2x.8a60ef2628ff583747d912ada4073a40.png); width: 166px; transform: translate(0px, 0px); opacity: 1">
                    <span>电子游艺</span><img src="/static/image/weixuanzhongdianziyouyi@2x.03b87e4b9f088d1ab2d9a5e80ebc68f9.png" height="40px" />
                  </li>
                </ul>
                <div class="con1">
                  <div class="games__bg__VnEEr bg">
                    <img src="/static/image/ty@5x.a37ed2b0b2c43c0d7420588637a1fddb.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.sportList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="games__bg__VnEEr bg" style="opacity: 0">
                    <img src="/static/image/dj@3x.83d58e52fe3dcdae81076bb9270a7067.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.gamingList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="games__bg__VnEEr bg" style="opacity: 0">
                    <img src="/static/image/zr@3x.788152124fcaceddcb15779235da34d0.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.realbetList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="games__bg__VnEEr bg" style="opacity: 0">
                    <img src="/static/image/qp@6x.015d5ab8a00e74f37cd360b39c713883.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.jokerList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="games__bg__VnEEr bg" style="opacity: 0">
                    <img src="/static/image/cp@7x.03016bd83654f2210cbf865be193e072.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.lotteryList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="games__bg__VnEEr bg" style="opacity: 0">
                    <img src="/static/image/dz@3x.ee147cc1d70e62669593c54b0c5391ec.png" width="1146px" />
                    <div class="games__buttons__PwhJ-">
                      <div
                        v-for="(item, index) in $store.state.conciseList"
                        :key="index"
                        v-if="index < 3"
                        @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                        style="background-image: url(/static/image/changguanxuanzhonganniu@2x.7e006449b9ff203eb4805313845d612f.png); width: 128px; z-index: 1"
                      >
                        <span data-venue="YBTY">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="scrollLazy" style="min-height: 200px">
          <div class="service__container__3dzDR animation-show" animation-show="true">
            <div>
              <div class="service__title__2cIjz"><img src="/static/image/service.14acf2b8dc2752073524b2c00a851ad0.png" height="66px" alt="" /></div>
              <div id="ob_service" class="service__wapper__8M2NB">
                <div class="service__service_con__1bXu2 animate_enter">
                  <div class="service__service_item__2E99q" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/home/fuwuyouhuikapian@2x.d53c603fceac6d6dabd6b165df72f133.png?x-oss-process=image/resize,p_100/format,webp')">
                    <div class="service__content__32sig">
                      <img src="/static/image/zhuanye@2x.9b0f3551ce8cf65a8a9852511ef3076f.png" width="100px" alt="" /><img src="/static/image/zy@2x.0bd872aea80eaaeb6863cbf91dfb31cf.png" width="80px" alt="" />
                      <p>每天为您提供近千场精彩体育赛事，更有真人、棋牌、彩票、电子游戏等多种娱乐方式供您选择，让您拥有完美游戏体验！</p>
                    </div>
                  </div>
                </div>
                <div class="service__service_con__1bXu2 animate_enter">
                  <div class="service__service_item__2E99q" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/home/fuwuyouhuikapian@2x.d53c603fceac6d6dabd6b165df72f133.png?x-oss-process=image/resize,p_100/format,webp')">
                    <div class="service__content__32sig">
                      <img src="/static/image/anquan@2x.f0b656cdad3ce8a42d7579555c425bf9.png" width="100px" alt="" /><img src="/static/image/aq@2x.063f9f9e5504bb214d45f5b7f519fa58.png" width="80px" alt="" />
                      <p>独家开发，采用128位加密技术和严格的安全管理体系，客户资金得到最全面的安全保障，让您尽享娱乐、赛事投注，无后顾之忧！</p>
                    </div>
                  </div>
                </div>
                <div class="service__service_con__1bXu2 animate_enter">
                  <div class="service__service_item__2E99q" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/home/fuwuyouhuikapian@2x.d53c603fceac6d6dabd6b165df72f133.png?x-oss-process=image/resize,p_100/format,webp')">
                    <div class="service__content__32sig">
                      <img src="/static/image/bainjie@2x.ddaa0144cce2ade3702424d103405ca8.png" width="100px" alt="" /><img src="/static/image/bj@2x.6ada770c7a5966276ddb4ecab006c193.png" width="80px" alt="" />
                      <p>引领市场的卓越技术，自主研发了全套终端应用，让您畅享Web、H5，更有iOS、Android原生App，为您提供最精致的娱乐投注体验！</p>
                    </div>
                  </div>
                </div>
                <div class="service__service_con__1bXu2 animate_enter">
                  <div class="service__service_item__2E99q" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/home/fuwuyouhuikapian@2x.d53c603fceac6d6dabd6b165df72f133.png?x-oss-process=image/resize,p_100/format,webp')">
                    <div class="service__content__32sig">
                      <img src="/static/image/kuaisu@2x.a730f5d36b02d490c8b25981f7d804c5.png" width="100px" alt="" /><img src="/static/image/ks@2x.63d0d1bc8fab87bea992ba0b97c5c262.png" width="80px" alt="" />
                      <p>采用最新技术自主研发的财务处理系统，真正做到极速存、取、转。独家网络优化技术，为您提供一流的游戏体验，最大优化网络延迟！</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar__floatMenu__EMITZ">
          <div class="sidebar__item__3ZxEn">
            <div @click="$parent.openKefu">
              <div class="sidebar__kefu__2c9mp"></div>
              <p>客服</p>
            </div>
          </div>
          <div class="sidebar__item__3ZxEn xf_ewm">
            <div>
              <div class="sidebar__qcode__2HvQg"></div>
              <p>二维码</p>
            </div>
            <div class="sidebar__qrcode__2PR2T" style="display: none">
              <img :src="$store.state.appInfo.ios_download_qrcode" onerror="this.src = '/static/image/appurl.jpg'" width="120" height="120" />
              <span>APP下载</span>
              <!-- <hr />
              <img :src="$store.state.appInfo.ios_download_qrcode" width="120" height="120" />
              <span>体育APP</span> -->
            </div>
          </div>
          <div class="sidebar__item__3ZxEn">
            <div @click="$parent.openKefu">
              <div class="sidebar__help__1b3r3"></div>
              <p>帮助</p>
            </div>
          </div>
          <div class="ant-back-top" style="opacity: 1; transform: translateX(0px)">
            <div class="sidebar__item__3ZxEn">
              <div>
                <div class="sidebar__gotop__2p1eZ"></div>
                <p>回到顶部</p>
              </div>
            </div>
          </div>
        </div>
        <div class="float-windows__floatWindows__1ERSp"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      bannerList: [],
      homenoticelis: [],
      message: null,
      ok: false,
      hongbashow: true,
      tanshow: true,
    };
  },
  created() { 
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
  },
  methods: {
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changMessage(msg) {
      console.log(123);
      this.message = msg;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
    $('.games__content__2kgrX ul li').click(function () {
      var index = $(this).index();
      $('.games__content__2kgrX ul li').siblings().removeClass('games__active__2El6O').eq(index).addClass('games__active__2El6O');
      $('.con1 .games__bg__VnEEr').siblings().animate({ opacity: '0', 'margin-left': '-100px' }, 200).eq(index).animate({ opacity: '1', 'margin-left': '' }, 500);
    });
  },
  updated() {
    let that = this;

    var swiper = new Swiper('.mySwiper', {
      speed: 1000,
      autoplay: {
        disableOnInteraction: false, //默认true
        delay: 3000, //默认3000
      },
      loop: true,
      navigation: {
        nextEl: '.style__next__3f6-g',
        prevEl: '.style__prev__14mIE',
      },
      pagination: {
        el: '.style__dots__2wknW',
        clickable: true,
      },
    });
    if (that.ok) {
      //公告滚动
      jQuery.fn.extend({
        pic_scroll: function () {
          $(this).each(function () {
            var _this = $(this); //存储对象
            var ul = _this.find('.home__marquee__3d0Ok'); //获取ul对象
            var li = ul.find('a'); //获取所有图片所有的li
            var w = li.size() * li.outerWidth(); //统计图片的长度
            li.clone().prependTo(ul); //克隆图片一份放入ul里
            ul.width(2 * w); //设置ul的长度，使所有图片排成一排
            var i = 1,
              l;
            _this.hover(
              function () {
                i = 0;
              },
              function () {
                i = 1;
              },
            ); //鼠标经过时设置i=0达到鼠标经过停止效果
            function autoScroll() {
              l = _this.scrollLeft();
              if (l >= w) {
                _this.scrollLeft(0);
              } else {
                _this.scrollLeft(l + i);
              }
            }
            var scrolling = setInterval(autoScroll, 20);
          });
        },
      });
      $('.home__notice_wrap__2_0lO').pic_scroll();
      that.ok = false;
    }
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
.home__marquee_Ok {
  float: left;
  overflow: hidden;
  position: relative;
  width: auto;
  height: 50px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue